module.exports = __webpack_public_path__ + "static/group-presentation-0dbbba4cc6185d55153b6ee9ff329169.jpg";